import React from "react";
import "./EditorLeftMenuPassportControls.css";
import PassportControlMenu from "./PassportControlMenu";

const EditorLeftMenuPassportControls = ({
  onSuggestCrop,
  onGenerate,
  busy = false,
  presetsLoading = false,
  error = null,
  suggestedCrop = null,
  selectedPreset = null,
  countryOptions = [],
  onCountryChange,
}) => {
  return (
    <div className="passport-controls-container">
      <h1>Passport Photo</h1>
      {error ? (
        <p className="passport-controls-error">{error}</p>
      ) : null}
      <PassportControlMenu
        selectedPreset={selectedPreset}
        countryOptions={countryOptions}
        onCountryChange={onCountryChange}
        onSuggestCrop={onSuggestCrop}
        onGenerate={onGenerate}
        busy={busy}
        presetsLoading={presetsLoading}
        suggestedCrop={suggestedCrop}
      />
    </div>
  );
};

export default EditorLeftMenuPassportControls;
